import React from 'react'

import { useSelector } from 'react-redux'

import { MenuPage } from 'routes/Menu/MenuExperience/MenuPage'
import { MenuRecipesPageWrapper } from 'routes/Menu/MenuRecipesPage'
import { getIsAuthenticated } from 'selectors/auth'

type MenuRouterProps = {
  params: {
    orderId?: string
  }
  location: {
    query: Record<string, unknown>
  }
}

export const MenuRouter = ({ params, location }: MenuRouterProps) => {
  const isAuthenticated = useSelector(getIsAuthenticated)

  if (isAuthenticated) {
    return <MenuPage params={params} location={location} />
  }

  return <MenuRecipesPageWrapper params={params} location={location} />
}
